<template>
  <el-upload
    class="upload_cp" style="margin-top: 20px" :show-file-list="false" drag action="/api/upload" name="file"
    :on-success="sus" :on-error="err" :limit="1"
  >
    <div v-if="vData" class="img_ctn"><img :src="vData" /></div>
    <template v-else>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </template>
    <template #tip>
      <div class="el-upload__tip">{{ tip || '只能上传 jpg/png 文件，且不超过 500kb' }}</div>
    </template>
  </el-upload>
</template>

<script>
  import { watch, ref, computed } from 'vue'
  export default {
    name: 'Upload',
    props: ['modelValue', 'cfg'],
    emits: ['update:modelValue', 'err'],
    setup(props, { emit }) {
      let { cfg } = props
      let tip = cfg && cfg.tip || ''

      let vData = ref(props.modelValue)
      watch(vData, v => {
        emit('update:modelValue', v)
      })

      // let vData = computed({
      //   get() {
      //     // console.log('get v ,', props.value)
      //     return props.modelValue
      //   },
      //   set(v) {
      //     console.log('set v ,', v)
      //     emit('update:modelValue', v)
      //   }
      // })

      return { vData, err, sus, tip };

      function sus(res) {
        // console.log(res)
        if (res && res.code === 1) {
          let data = res.data && res.data.url || ''
          // console.log(data === vData)
          vData.value = data
          console.log(vData)
        }
      }

      function err (e) {
        console.log(err)
        emit('err', e)
      }
    }
  }
</script>

<style lang="less" scoped>
  img {
    width: 200px;
  }

  .upload_cp {
    :deep(.el-upload__text) {
      margin-top: 50px;
    }
  }

</style>
